import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reorder } from '../actions/content'
import { push } from '../history'
import utils from '../lib/utils'
import TreeSortContainer from '../components/TreeSortContainer'
import sortby from 'lodash.sortby'
import Content from '../components/Content'

@connect(null)
export default class Tree extends Component {
  static propTypes = {
    items: PropTypes.array,
    type: PropTypes.object
  }

  state = {
    filter: '',
    tree: this.getTree(this.props.items)
  }

  componentWillReceiveProps (props) {
    this.setState({tree: this.getTree(props.items)})
  }

  getTree (items, parentId = null) {
    return sortby(items.filter(item => item.parent_id === parentId), 'position')
      .map(item => {
        const children = this.getTree(items, item.id)
        return {id: item.id, item, children}
      })
  }

  moveItem = (id, afterId, nodeId) => {
    if (id === afterId) return

    let {tree} = this.state

    const removeNode = (id, items) => {
      for (const node of items) {
        if (node.id === id) {
          items.splice(items.indexOf(node), 1)
          return
        }

        if (node.children && node.children.length) {
          removeNode(id, node.children)
        }
      }
    }

    const findNode = (id, items) => {
      for (const node of items) {
        if (node.id === id) {
          return node.children
        }

        if (node.children && node.children.length) {
          const result = findNode(id, node.children)
          if (result) {
            return result
          }
        }
      }

      return false
    }

    const item = {...this.findItem(id)}
    if (!item.id) {
      return
    }

    const dest = nodeId ? findNode(nodeId, tree) : tree

    if (!afterId) {
      removeNode(id, tree)
      dest.push(item)
    } else {
      const index = dest.indexOf(dest.filter(v => v.id === afterId).shift())
      removeNode(id, tree)
      dest.splice(index, 0, item)
    }

    this.setState({tree})
  }

  findItem = (id, items = null) => {
    if (!items) {
      items = this.state.tree
    }

    for (const node of items) {
      if (node.id === id) return node
      if (node.children && node.children.length) {
        const result = this.findItem(id, node.children)
        if (result) {
          return result
        }
      }
    }

    return false
  }

  didSort = async () => {
    const {dispatch, type} = this.props
    const {tree} = this.state

    await dispatch(reorder(tree, type.id))
  }

  filter = (content) => {
    const filterValue = this.state.filter.toLowerCase()

    for (const key in content) {
      const value = (content[key] || '').toString().toLowerCase()
      if (value.indexOf(filterValue) > -1) return true
    }

    return false
  }

  onFilter = (e) => {
    const filter = e.target.value
    this.setState({filter})
  }

  renderItem = ({item, children}) => {
    return <Content key={item.id} content={item}
      onClick={e => push(utils.contentUrl(item.id))}
    >
      <TreeSortContainer
        itemType='CONTENT'
        nodeId={item.id}
        items={children}
        move={this.moveItem}
        drop={this.didSort}
        renderItem={this.renderItem}
        className='nested-children'
      />
    </Content>
  }

  renderSearchResults () {
    const items = this.props.items.filter(this.filter.bind(this))
    return items.map(item => {
      return <Content key={item.id} content={item} onClick={e => {
        push(utils.contentUrl(item.id))
      }} />
    })
  }

  render () {
    const {tree, filter} = this.state

    return <div className='content-list layout-default'>
      <div className='content-search'>
        <input type='search' placeholder='Search for content...' value={filter}
          onKeyUp={this.onFilter} onChange={this.onFilter} />
      </div>
      <div className='content-table'>
        {(filter && filter.length)
          ? this.renderSearchResults()
          : <TreeSortContainer
            itemType='CONTENT'
            nodeId={null}
            items={tree}
            move={this.moveItem}
            drop={this.didSort}
            renderItem={this.renderItem}
            className='content-table-body'
          />
        }
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/LayoutTree.js